import(/* webpackMode: "eager", webpackExports: ["ScrollBar"] */ "/app/apps/website/src/app/(rootLayout)/conseils-inspirations/[slug]/_components/scroll-bar.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/website/src/app/(rootLayout)/destinations/[slug]/_components/hero/booqable-content.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/website/src/app/(rootLayout)/destinations/[slug]/_components/hero/hero.css");
;
import(/* webpackMode: "eager" */ "/app/apps/website/src/app/(rootLayout)/destinations/[slug]/_components/markdown-styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/packages/map/map.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea","ScrollBar"] */ "/app/packages/ui/src/components/ui/scroll-area.tsx");
